import moment from "moment";

const dateFormat = "YYYY-MM-DD";
const momentDate = (value) => {
  const date = moment(value);
  return date.isValid() ? date : moment();
};

export const odata = {
  contains: (columnName, value) => {
    value = value.replaceAll("'", '"');
    return `contains(tolower(${columnName}), tolower('${encodeURIComponent(value)}'))`;
  },
  notContains: (columnName, value) => {
    value = value.replaceAll("'", '"');
    return `not contains(tolower(${columnName}), tolower('${value}'))`;
  },
  dateRange: (columnName, startDate, endDate) => {
    const formatedStartDate = momentDate(startDate).format(dateFormat);
    const formatedEndDate = momentDate(endDate)
      .add(1, "days")
      .format(dateFormat);

    return `date(${columnName}) ge ${formatedStartDate} and date(${columnName}) lt ${formatedEndDate}`;
  },
  dateCompare: (columnName, compareLetter, date) => {
    const formatedDate = momentDate(date).format(dateFormat);

    return `date(${columnName}) ${compareLetter} date(${formatedDate})`;
  },
  dateCompareValueBefore: (date, compareLetter, columnName) => {
    return odata.dateCompare(columnName, compareLetter, date);
  },
  ConditionalRange: (columnName, minValue, maxValue) => {
    const conditions = [];

    if (minValue || minValue === 0) {
      conditions.push(`${columnName} Ge ${minValue}`);
    }

    if (maxValue || maxValue === 0) {
      conditions.push(`${columnName} Le ${maxValue}`);
    }

    return conditions.join(" and ");
  },
  orderBy: (columnName) => {
    return `$orderby=${columnName} asc`;
  },
  orderByDesc: (columnName) => {
    return `$orderby=${columnName} desc`;
  },
};

export const queryHelper = {
  getQueryFromValues: (values, prefix, appendOtherPrefixes) => {

    const valueQueries = Object.keys(values)
      .filter(key => values[key] || values[key] === 0)
      .map(key => prefix ? `${prefix + key}=${values[key]}` : `${key}=${values[key]}`);

    //aynı ekranda iki ayrı component filtreside tutulması için prefixle başlamayanlarıda ekliyoruz.
    if (prefix && appendOtherPrefixes) {

      const queryString = new URLSearchParams(window ? window.location.search : {});

      //verilen prefix ile başlayanlar valuedan eklendiği için queryStringte kalan diğer değerleri varolan keyi ile ekliyoruz.
      queryString.forEach((value, key) => {
        if (!key.startsWith(prefix)) {
          valueQueries.push(`${key}=${value}`);
        }
      });
    }

    return valueQueries.join("&");
  },
  getFilterValuesFromQuery: (prefix) => {
    const queryString = new URLSearchParams(window ? window.location.search : {});
    const values = {};
    const ignoredKeys = ["skip", "take", "current", "order", "filter"];
    const ignoredPrefixedKeys = prefix ? ignoredKeys.map(key => `${prefix}${key}`) : ignoredKeys;

    queryString.forEach((value, key) => {
      if (!ignoredPrefixedKeys.includes(key)) {

        //prefix varsa da dönüşte prefixsiz dönüyoruz. Prefixi aynı ekranda birden fazla component için kullanılan veriyi urlde ayrıştırmak için kullanıyoruz.
        if (prefix) {
          if (key.startsWith(prefix)) {
            values[key.replace(prefix, "")] = value;
          }
        } else {
          values[key] = value;
        }

      }
    })

    return values;
  },
  getFilterFromQuery: (prefix) => {
    const queryString = new URLSearchParams(window ? window.location.search : {});
    const filter = queryString.get(prefix ? `${prefix}filter` : "filter");

    return filter ? filter : "";
  },
  getPagingValuesFromQuery: (prefix) => {
    const queryString = new URLSearchParams(window ? window.location.search : {});
    const values = {};

    const keys = ["skip", "take", "current", "order"];
    const prefixedKeys = prefix ? keys.map(key => `${prefix}${key}`) : keys;
    prefixedKeys.forEach((key) => {
      const value = queryString.get(key);
      if (value || value === "0") {

        const orderKey = prefix ? prefix + "order" : "order";

        values[key.replace(prefix, "")] = key === orderKey ? value : parseInt(value);
      }
    })

    return values;
  },
  getDefaultTableDataQueryOptions: (prefix) => Object.assign({
    skip: 0,
    take: 15,
    current: 1,
    order: "",
    filter: queryHelper.getFilterFromQuery(prefix),
    values: queryHelper.getFilterValuesFromQuery(prefix),
  }, queryHelper.getPagingValuesFromQuery(prefix)),
  getTableDataQueryOptions: (defaultOptions, prefix) => Object.assign(
    defaultOptions, queryHelper.getFilterValuesFromQuery(prefix), queryHelper.getPagingValuesFromQuery(prefix)),
};
